import { AssetUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/asset_events_pb';
import { Col, DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

import { assetStatusLabels } from '../enumLabels';

type AssetUpdatedDetailProps = {
  event: AssetUpdatedEvent;
};

export const AssetUpdatedDetail = ({ event }: AssetUpdatedDetailProps) => {
  const previous = event.previousAsset;
  const current = event.updatedAsset;

  if (!previous || !current) {
    return (
      <Col className="@AssetUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'identifier',
      label: 'Identifier',
      previous: previous.identifier,
      current: current.identifier,
    },
    {
      field: 'status',
      label: 'Status',
      previous: assetStatusLabels[previous.status],
      current: assetStatusLabels[current.status],
    },
    {
      field: 'description',
      label: 'Description',
      previous: previous.description,
      current: current.description,
    },
    {
      field: 'accountId',
      label: 'Account ID',
      previous: previous.accountId?.value ?? '',
      current: current.accountId?.value ?? '',
    },
    {
      field: 'facilityId',
      label: 'Facility ID',
      previous: previous.facilityId?.value ?? '',
      current: current.facilityId?.value ?? '',
    },
    {
      field: 'typeId',
      label: 'Type ID',
      previous: previous.typeId?.value ?? '',
      current: current.typeId?.value ?? '',
    },
  ];

  return (
    <Col className="@AssetUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">Asset</span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id?.value} />
          <FieldDisplay label="Identifier" value={current.identifier} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Changes
        </span>
        <DiffViewer diffs={diffs} previousLabel="Before" currentLabel="After" />
      </Col>
    </Col>
  );
};
